<template>
    <!-- <v-row class="admin-container"> -->
    <v-row justify="center">
        <v-col cols="12" lg="11" class="admin-container">
            <!-- Header with Add User Button -->
            <div class="header-actions">
                <v-btn color="primary" class="add-user-btn" elevation="2" @click="openCreateDIalog()">
                    <v-icon left>mdi-account-plus</v-icon>
                    פתח משתמש חדש
                </v-btn>
            </div>

            <!-- Search and Stats Card -->
            <v-card class="search-card" elevation="2">
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" md="4" sm="6">
                            <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" label="חיפוש משתמש" outlined
                                dense hide-details background-color="white" class="search-field"
                                @input="handleSearchInput"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="8" sm="6" class="d-flex align-center">
                            <div class="user-count">
                                <v-icon color="#0d2c6d" class="ml-2">mdi-account-group</v-icon>
                                <span>סך הכל <strong>{{ totalItems }}</strong> משתמשים</span>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <!-- Users Data Table Card -->
            <v-card class="data-table-card" elevation="2">
                <v-data-table id="table1" :headers="headers" :items="ivrs" sort-by="createdAt" sort-desc
                    :loading="progressShow" loading-text="טוען נתונים..." no-data-text="אין עדיין מערכות"
                    :server-items-length="totalItems" :items-per-page="itemsPerPage" :page.sync="currentPage"
                    :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @update:items-per-page="onItemsPerPageChange"
                    @update:page="onPageChange" @update:sort-by="onSortChange" @update:sort-desc="onSortChange"
                    :footer-props="{
                        'items-per-page-options': [20, 50, 100, 500], 'items-per-page-text': 'שורות בעמוד:', showFirstLastPage: true,
                        firstIcon: 'mdi-chevron-double-left',
                        lastIcon: 'mdi-chevron-double-right',
                        prevIcon: 'mdi-chevron-left',
                        nextIcon: 'mdi-chevron-right'
                    }">
                    <template v-if="$vuetify.breakpoint.mdAndUp" v-for="header in headers"
                        v-slot:[`header.${header.value}`]="{ header }">
                        <span class="table-header-text">{{ header.text }}</span>
                    </template>

                    <template v-if="$vuetify.breakpoint.mdAndUp" #item="{ item, index }">
                        <tr :class="item.status ? 'table-row' : 'table-row-disabled'">
                            <td class="table-cell">{{ index + 1 }}</td>
                            <td class="table-cell">{{ item.line_number }}</td>
                            <td class="table-cell">{{ item.owner_details.name }}</td>
                            <!-- <td class="table-cell">{{ item.owner_details.business_name }}</td> -->
                            <td class="table-cell">{{ item.owner_details.phone }}</td>
                            <!-- <td class="table-cell" style="max-width: 70px !important;">{{ item.owner_details.email }}</td> -->
                            <td class="table-cell">
                                <v-chip small :color="getRoleColor(item.role)" text-color="white">
                                    {{ item.role === 'admin' ? 'מנהל' : item.role === 'user' ? 'משתמש' : 'סוכן' }}
                                </v-chip>
                            </td>
                            <td class="table-cell" style="max-width: 50px !important;">{{ item.belong_to_agent }}</td>
                            <td class="table-cell">{{ item.last_call ? formatDate(item.last_call) : '-' }}</td>
                            <td class="table-cell">{{ item.last_visit }}</td>
                            <td class="table-cell">
                                <div class="d-flex align-center justify-center" style="gap: 6px;">
                                    <v-chip small color="#6a6aec" text-color="white">
                                        {{ item.plan.plan_id.name }}
                                    </v-chip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon x-small v-on="on" color="#6a6aec"
                                                @click="openPlanHistory(item)">
                                                <v-icon small>mdi-history</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Plan History</span>
                                    </v-tooltip>
                                </div>
                            </td>
                            <td class="table-cell">{{ formatDate(item.createdAt) }}</td>
                            <td class="table-cell">
                                <div class="action-buttons" v-if="item.role !== 'admin'">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon small v-on="on" color="#0d2c6d"
                                                @click="openEditDialog(item, index)">
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>עריכה</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon small v-on="on" color="#0d2c6d" @click="switchToUser(item)">
                                                <v-icon>mdi-login-variant</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>כניסה למערכת</span>
                                    </v-tooltip>
                                </div>
                            </td>
                        </tr>
                    </template>

                    <!-- Mobile display -->
                    <template v-slot:item.actions="{ item, index }">
                        <div class="action-buttons">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon small v-on="on" color="#0d2c6d" @click="openEditDialog(item, index)">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </template>
                                <span>עריכה</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="item.role !== 'admin'">
                                <template v-slot:activator="{ on }">
                                    <v-btn icon small v-on="on" color="#0d2c6d" @click="switchToUser(item)">
                                        <v-icon>mdi-login-variant</v-icon>
                                    </v-btn>
                                </template>
                                <span>כניסה למערכת</span>
                            </v-tooltip>
                        </div>
                    </template>

                    <template v-slot:no-data>
                        <v-row v-if="progressShow" class="my-5">
                            <v-col class="d-flex justify-center">
                                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                            </v-col>
                        </v-row>
                        <div class="empty-state">
                            <v-icon size="64" color="#0d2c6d">mdi-account-off</v-icon>
                            <span class="empty-text">אין עדיין משתמשים</span>
                            <v-btn color="primary" @click="refreshDetails()" class="mt-4">
                                <v-icon left>mdi-refresh</v-icon>
                                רענן
                            </v-btn>
                        </div>
                    </template>
                </v-data-table>
            </v-card>

            <!-- Dialogs -->
            <AddEditDialog v-model="addEditDialog" v-if="addEditDialog" :formTitle="formTitle" :itemToEdit="editedItem"
                @ivrCreated="newIvrSaved" @ivrEdited="editedIvrSaved"></AddEditDialog>

            <!-- Plan History Dialog -->
            <v-dialog v-model="planHistoryDialog" max-width="600px">
                <v-card>
                    <v-card-title class="plan-history-header">
                        <v-icon class="mr-2" color="white">mdi-history</v-icon>
                        Plan History
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="planHistoryDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="pt-4">
                        <div v-if="selectedPlanHistory.length === 0" class="text-center py-6 grey--text">
                            <v-icon size="48" color="grey lighten-1">mdi-package-variant</v-icon>
                            <div class="mt-2">No plan history available</div>
                        </div>
                        <v-timeline dense v-else>
                            <v-timeline-item v-for="(plan, i) in selectedPlanHistory" :key="i" color="#6a6aec" small>
                                <v-card outlined class="pa-3">
                                    <div class="d-flex justify-space-between align-center">
                                        <v-chip small color="#6a6aec" text-color="white">
                                            {{ plan.plan_id && plan.plan_id.name ? plan.plan_id.name : plan.plan_id }}
                                        </v-chip>
                                        <span class="caption grey--text">{{ formatDate(plan.replaced_at) }}</span>
                                    </div>
                                    <div class="mt-2 caption">
                                        <span v-if="plan.hok_id">Hok: {{ plan.hok_id }}</span>
                                        <span v-if="plan.last_digits" class="ml-3">Card: **** {{ plan.last_digits
                                            }}</span>
                                        <span v-if="plan.start_pay_date" class="ml-3">Start: {{
                                            formatDate(plan.start_pay_date)
                                            }}</span>
                                    </div>
                                </v-card>
                            </v-timeline-item>
                        </v-timeline>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
        </v-col>
    </v-row>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'
import utils from '@/util/utils'
import Auth from '@/services/auth.service.js'
import AddEditDialog from '@/components/admin/dialogs/AddEditDialog'
import { mapState, mapMutations } from 'vuex';
import _ from 'lodash'

export default {
    components: {
        SnackBar,
        AddEditDialog
    },
    data: () => ({
        snackbar: false,
        snackbarColorBt: "green",
        snacbarText: "",
        lineNumber: "",
        progressShow: false,
        addEditDialog: false,
        formTitle: "",
        editedItem: {},
        itemToDelete: {},
        deleteDialog: false,
        planHistoryDialog: false,
        selectedPlanHistory: [],
        search: "",
        totalItems: 0,
        currentPage: 1,
        itemsPerPage: 20,
        sortBy: 'createdAt',
        sortDesc: true,
        ivrs: [],
        headers: [
            { text: '#', value: "index", sortable: false, width: '50px' },
            { text: 'שם משתמש', value: 'line_number' },
            { text: 'שם איש קשר', value: 'owner_details.name' },
            // { text: 'שם מוסד', value: 'owner_details.business_name' },
            { text: 'טלפון', value: 'owner_details.phone' },
            // { text: 'דוא"ל', value: 'owner_details.email', width: '20px' },
            { text: 'סיווג', value: 'role', width: '100px' },
            { text: 'משוייך לסוכן', value: 'belong_to_agent' },
            { text: 'שיחה אחרונה', value: 'last_call' },
            { text: 'התחברות אחרונה', value: 'last_visit' },
            { text: 'חבילה', value: 'plan.plan_name', width: '120px' },
            { text: 'נוצר בתאריך', value: 'createdAt', width: '120px' },
            { text: 'פעולות', value: 'actions', sortable: false, width: '120px' },
        ],
    }),
    methods: {
        ...mapMutations(['TOGGLE_ADMIN_SWITCH', 'TOGGLE_AGENT_SWITCH']),

        getRoleColor(role) {
            switch (role) {
                case 'admin': return '#ff5252';
                case 'agent': return '#fb8c00';
                default: return '#0d2c6d';
            }
        },

        async getIvrs() {
            try {
                this.progressShow = true;
                let token = localStorage.getItem("token");

                const query = new URLSearchParams({
                    page: this.currentPage,
                    itemsPerPage: this.itemsPerPage,
                    sortBy: this.sortBy || '',
                    sortDesc: this.sortDesc ? 'desc' : 'asc',
                    search: this.search || ''
                }).toString();

                let api = process.env.VUE_APP_BASE_URL + `/admin_api/get_ivrs_list?${query}`;
                const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
                const jsonObject = await res.json();
                this.progressShow = true;
                if (res.status >= 400) {
                    this.progressShow = true;
                    this.showSnackBar("שגיאה בקבלת נתונים", "red");
                } else if (res.status === 200) {
                    this.ivrs = jsonObject.items || [];
                    this.totalItems = jsonObject?.totalItems || 0;
                    this.progressShow = false;
                }
            } catch (error) {
                this.showSnackBar("Error get subscribes: " + error, "red");
            }
        },
        formatDate(date) {
            return utils.getCurrentDate(date)
        },
        showSnackBar(message, color) {
            this.snacbarText = message;
            this.snackbarColorBt = color;
            this.snackbar = true
        },
        openEditDialog(item, index) {
            this.formTitle = "ערוך משתמש:"
            this.editedItem = item
            this.addEditDialog = true
        },
        openCreateDIalog() {
            this.formTitle = "פתח משתמש חדש:"
            this.editedItem = {}
            this.addEditDialog = true
        },
        newIvrSaved(item, text, color) {
            this.showSnackBar(text, color)
            if (item === "") {
                return
            }
            this.ivrs.push(item);
        },
        editedIvrSaved(item, text, color) {
            this.showSnackBar(text, color)
            if (item === "") {
                return
            }
            const index = this.ivrs.findIndex(ivr => ivr._id === item._id);
            let g = Object.assign(this.ivrs[index], item);
        },
        async switchToUser(item) {
            this.progressShow = true
            let token = localStorage.getItem("token");
            localStorage.setItem('tokenAdmin', token);
            let MyJSON = JSON.stringify({ _id: item._id });
            let api = process.env.VUE_APP_BASE_URL + "/admin_api/swich_to_user"

            try {
                const response = await fetch(api, ApiServices.requestOptions("POST", MyJSON, token));
                this.progressShow = false;
                const jsonObject = await response.json();
                if (response.status >= 400) {
                    this.showSnackBar("שגיאת התחברות: " + jsonObject.message, "red");
                } else if (response.status === 200) {
                    localStorage.setItem('token', jsonObject.token);
                    this.TOGGLE_ADMIN_SWITCH();
                    this.$router.replace({ name: "home" })
                }
            } catch (error) {
                this.showSnackBar("Error Login: " + error, "red");
            }
        },
        openPlanHistory(item) {
            this.selectedPlanHistory = item.plan_history || [];
            this.planHistoryDialog = true;
        },
        refreshDetails() {
            this.getIvrs();
        },
        // === events של סרבר פייגינג ===
        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getIvrs();
        },
        onItemsPerPageChange(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.getIvrs(true);
        },
        onSortChange() {
            this.debouncedGetIVrs(true);
        },
        handleSearchInput() {
            if (this.search) {
                this.debouncedGetIVrs(true);
            } else {
                this.getIvrs(true);
            }
        }
    },
    mounted() {
        this.lineNumber = Auth.getLineNumber();
        this.getIvrs();
        this.debouncedGetIVrs = _.debounce(this.getIvrs, 700);

    },
}
</script>

<style scoped>
.admin-container {
    /* margin: 0 auto;
    padding: 0 16px;
    direction: rtl; */
    font-family: 'Heebo', sans-serif;
}

.header-actions {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 24px;
}

.add-user-btn {
    background: linear-gradient(135deg, #ffb91a 0%, #ffd166 100%) !important;
    color: #0d2c6d !important;
    font-weight: 600;
    padding: 0 24px;
    height: 48px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.add-user-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.search-card {
    margin-bottom: 24px;
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease;
}

.search-card:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
}

.search-field {
    border-radius: 8px;
}

.user-count {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #0d2c6d;
}

.data-table-card {
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease;
    margin-bottom: 40px;
}

.data-table-card:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
}

.users-table {
    width: 100%;
}

.table-header-text {
    font-size: 16px;
    font-weight: 600;
    color: #0d2c6d;
}

.table-row {
    height: 60px !important;
    transition: background-color 0.2s ease;
}

.table-row-disabled {
    background-color: rgba(243, 32, 60, 0.178) !important;
}

.table-row:hover {
    background-color: rgba(13, 44, 109, 0.05) !important;
}

.table-cell {
    font-size: 14px;
    color: #333;
    text-align: center !important;
}

.action-buttons {
    display: flex;
    justify-content: center;
    gap: 8px;
}

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px 0;
}

.empty-text {
    font-size: 20px;
    font-weight: 600;
    color: #0d2c6d;
    margin-top: 16px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
    .admin-container {
        padding: 0 12px;
    }

    .header-actions {
        margin-bottom: 16px;
    }

    .table-header-text {
        font-size: 14px;
    }

    .table-cell {
        font-size: 13px;
    }
}

@media (max-width: 600px) {
    .add-user-btn {
        width: 100%;
    }

    .search-card,
    .data-table-card {
        border-radius: 8px;
    }

    .user-count {
        justify-content: center;
        margin-top: 8px;
    }
}


.plan-history-header {
    background: linear-gradient(135deg, #6a6aec 0%, #8a8aff 100%);
    color: white;
    font-size: 1.1rem;
    font-weight: 600;
}

#table1.v-data-table>>>.v-data-table-header th {
    background-color: rgba(0, 0, 0, 0.116) !important;
    border-left: 1px solid white !important;
}
</style>